<div
	class="modal-body text-center"
	style="display: flex; justify-content: flex-end"
>
	<!-- <h5 *ngIf="title">{{ title }}</h5> -->
	<button
		type="button"
		class="close"
		aria-label="Close"
		(click)="close()"
		style="float: unset"
	>
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="modal-content d" style="height: 80vh">
	<!-- <form
		action="#"
		autocomplete="off"
		(ngSubmit)="onSubmit()"
		[formGroup]="form"
	>
		<div class="form-modal px-4">
			<div class="w-100">
				<app-input
					id="days"
					name="days"
					typeInput="text"
					placeholder="Número de dias"
					labelName="Número de dias"
					[form]="form"
				></app-input>
			</div>
			<div class="w-100">
				<app-input
					id="cid"
					name="cid"
					typeInput="text"
					placeholder="CID"
					labelName="CID"
					[form]="form"
				></app-input>
			</div>
		</div>
	</form> -->
	<iframe [src]="safeUrl" width="100%" height="100%"></iframe>
</div>
<div class="modal-footer">
	<!-- <button type="button" class="btn outline" (click)="close()">
		Cancelar
	</button>
	<button type="button" class="btn btn-xs" (click)="onSubmit()">
		Confirmar
	</button> -->
</div>
